import { Shipment } from "@/model/transportorder/transportOrder"
import { createSlice, PayloadAction } from "@reduxjs/toolkit"

export interface AdminUIState {
    selectedTransportOrder?: Shipment
}

export const initialAdminUIState: AdminUIState = {
    selectedTransportOrder: undefined,
}

export const adminUiSlice = createSlice({
    name: "adminUi",
    initialState: initialAdminUIState,
    reducers: {
        setSelectedTransportOrder: (state, action: PayloadAction<Shipment | undefined>) => {
            state.selectedTransportOrder = action.payload
        },
    }
})
